import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import "@/i18n";
import App from "@/App";
import RootErrorBoundary from "@/components/RootErrorBoundary";

const APP_CACHE_PREFIXES = ['tanzeen-web-', 'lea-quran-'];

const clearDevelopmentServiceWorkerState = async () => {
  if ('serviceWorker' in navigator) {
    const registrations = await navigator.serviceWorker.getRegistrations();
    await Promise.all(registrations.map((registration) => registration.unregister()));
  }

  if ('caches' in window) {
    const cacheNames = await caches.keys();
    await Promise.all(
      cacheNames
        .filter((cacheName) => APP_CACHE_PREFIXES.some((prefix) => cacheName.startsWith(prefix)))
        .map((cacheName) => caches.delete(cacheName))
    );
  }
};

// Preview/development bundles change frequently. A persistent worker can serve an
// older app shell while the preview server wakes, producing a stale startup crash.
if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js')
      .then((registration) => {
        console.log('SW registered:', registration.scope);
      })
      .catch((error) => {
        console.log('SW registration failed:', error);
      });
  });
} else {
  clearDevelopmentServiceWorkerState().catch((error) => {
    console.warn('Preview service-worker cleanup failed:', error);
  });
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <RootErrorBoundary>
      <App />
    </RootErrorBoundary>
  </React.StrictMode>,
);
